// "Notes System" setting, mirroring Android's user_setting_enable_notes_system
// (DataStore). On web it lives in localStorage only (no Firebase persistence
// yet). Default OFF — the Notes tab is hidden until the user opts in, exactly
// like Android.
export const NOTES_ENABLED_KEY = "user_setting_enable_notes_system";
export const NOTES_PROMPT_SHOWN_KEY = "notes_system_prompt_shown";

// Show the one-shot "turn on notes?" prompt once the user has this many
// non-note tasks. Matches Android's NOTES_PROMPT_TASK_THRESHOLD = 10.
export const NOTES_PROMPT_TASK_THRESHOLD = 10;

export const isNotesSystemEnabled = () => {
  try {
    return localStorage.getItem(NOTES_ENABLED_KEY) === "true";
  } catch (e) {
    return false;
  }
};

export const setNotesSystemEnabled = (enabled) => {
  try {
    localStorage.setItem(NOTES_ENABLED_KEY, String(enabled));
  } catch (e) {
    /* ignore */
  }
};

export const isNotesPromptShown = () => {
  try {
    return localStorage.getItem(NOTES_PROMPT_SHOWN_KEY) === "true";
  } catch (e) {
    return false;
  }
};

export const markNotesPromptShown = () => {
  try {
    localStorage.setItem(NOTES_PROMPT_SHOWN_KEY, "true");
  } catch (e) {
    /* ignore */
  }
};
